// import React from 'react';
// import { Link } from 'react-router-dom';
// import '../styles/BlogCard.css';

// const BlogCard = ({ post }) => {
//   return (
//     <Link to={`/blog/${post.slug}`} className="blog-card">
//       <div className="blog-card-image">
//         {post.category && (
//           <div className="blog-card-category">{post.category}</div>
//         )}
//         <img src={post.coverImage} alt={post.title} />
//       </div>
//       <div className="blog-card-content">
//         <h2 className="blog-card-title">{post.title}</h2>
//         <p className="blog-card-description">{post.description}</p>
//         <div className="blog-card-meta">
//           <div className="blog-card-author">
//             {post.authorImage && (
//               <img src={post.authorImage} alt={post.author} className="blog-card-author-image" />
//             )}
//             <span>{post.author}</span>
//           </div>
//           {post.date && <span className="blog-card-date">{post.date}</span>}
//         </div>
//       </div>
//     </Link>
//   );
// };

// export default BlogCard;


// src/components/BlogCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/BlogCard.css';

const BlogCard = ({ post }) => {
  return (
    <Link to={`/blog/${post.slug}`} className="blog-card">
      <div className="blog-card-image">
        {post.category && (
          <div className="blog-card-category">{post.category}</div>
        )}
        <img src={`${process.env.PUBLIC_URL}${post.coverImage}`} alt={post.title} />
      </div>
      <div className="blog-card-content">
        <h2 className="blog-card-title">{post.title}</h2>
        <p className="blog-card-description">{post.description}</p>
        <div className="blog-card-meta">
          <div className="blog-card-author">
            {post.authorImage && (
              <img 
                src={`${process.env.PUBLIC_URL}${post.authorImage}`} 
                alt={post.author} 
                className="blog-card-author-image" 
              />
            )}
            <span>{post.author}</span>
          </div>
          {post.date && <span className="blog-card-date">{post.date}</span>}
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;